import { useLocalStorage } from "@mantine/hooks"

export const useCopilotStorage = () => {
    const [isOpen, setIsOpen] = useLocalStorage({
        key: "ai-chat-is-open",
        defaultValue: false,
    })

    const [entryPoint, setEntryPoint] = useLocalStorage({
        key: "ai-chat-entrypoint",
        defaultValue: "",
    })

    const [selectedProfileName, setSelectedProfileName] = useLocalStorage({
        key: "ai-chat-selected-profile-name",
        defaultValue: "",
    })

    return {
        isOpen,
        entryPoint,
        selectedProfileName,
        setIsOpen,
        setEntryPoint,
        setSelectedProfileName,
    }
}
